
import React, {useEffect, useState} from 'react';


import {
	createPayment_69fce3d85276935741630b32,
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_carriton0fqi,
} from '../../actions/auth.actions';

import {createeventoyl90t } from '../../api/eventoyl90t.api'

import './eventosr413q.scss';


const loftyShouldRenderCarousel = (products = []) => {
  const loftyIsMobile = window.innerWidth < 464;
  if (loftyIsMobile) {
    return true;
  }
  return products.length > 3;
}


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Peventosr413q = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_carriton0fqi,
	set_lofty_global_carriton0fqi_app,

}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69cd72e9ee7dda37b6dc76ff" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i6edva"
          href="/"
        >
          
    <div id="iysqr8" className="">
    <>Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iy44bl"
          href="/menu"
        >
          
    <div id="i41p5g" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyf8jb"
          href="/eventos"
        >
          
    <div id="iztdq8" className="">
    <>Reservaciones</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i377lh"
          href="/unite"
        >
          
    <div id="io6x2g" className="">
    <>Únete a nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i3knlt"
          href="/ubicaciones"
        >
          
    <div id="ie1esj" className="">
    <>Ubicaciones</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="inff1e" className="">
      
        <a
          target=""
          className=""
          id="ijhswy"
          href="/carrito"
        >
          
    <div id="i7kn2y" className="">
    <>Carrito</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Menú</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Eventos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Únete a nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Ubicaciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Carrito</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihk8" className="">
      
      <div id="iym0il" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Eventos Especiales</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i803s">
        <>Celebra tus momentos especiales con el auténtico sabor hondureño</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="iiaa8f">
        <>Nuestra Esencia</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijh55q">
        <>Lo Que Nos Define</>
      <br className="" id="" />
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div id="idydx" className="">
      
      <div id="ikpy3f" className="">
      
      <div id="im9bo1" className="">
      
      <img
        className=""
        id="i1jvnf"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngg8mkj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="iqypdu">
        <>Planificación Personalizada</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iyi33">
        <>Trabajamos contigo para diseñar el menú perfecto para tu evento.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i56t75" className="">
      
      <div id="i6tai" className="">
      
      <div id="i4blkk" className="">
      
      <img
        className=""
        id="ilqcl"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngg9fk5.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ivfd5">
        <>Cualquier Tamaño</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iit6zr">
        <>Desde reuniones íntimas hasta grandes celebraciones, nos adaptamos.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i4jqpk" className="">
      
      <div id="i5tcm5" className="">
      
      <div id="ifbiv9" className="">
      
      <img
        className=""
        id="iua6pk"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngga7ku.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div className="" id="ia9x99">
        <>Experiencia Auténtica</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="i071f3">
        <>Lleva los sabores de Honduras a tu evento especial.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ibggxg" className="">
      
      <div className="" id="idgmzn">
        <>Cotización</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijzd2g">
        <>Solicita Tu Cotización</>
      <br className="" id="" />
      
      </div>
      
      <div id="idvyho" className="">
      
        <div className="" id="i8xe31">
          
      <form
        id="ia00b2"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createeventoyl90t({
						token: 'aasdas',
						nombrecompletob9gnh: e.target.nombrecompletob9gnh?.value,
						correovfh23: e.target.correovfh23?.value,
						telfononf206: e.target.telfononf206?.value,
						cantidaddepersonasd96qf: e.target.cantidaddepersonasd96qf?.value,
						undefined: e.target.undefined?.value,
						descripcinns3bw: e.target.descripcinns3bw?.value,
					});
					alert("Se ha enviado exitosamente");
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="i0y4sc" className="">
      
      <label id="" className="">
      <>Nombre completo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombrecompletob9gnh"
        type="text"
        placeholder="Eduardo Maldonado"
        className="form-control "
        id="i9721z"
      />
      
      </div>
      
      <div id="i2iktn" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correovfh23"
        type="text"
        placeholder="tu@correo.com"
        className="form-control "
        id="ias91g"
      />
      
      </div>
      
      <div id="igdsml" className="">
      
      <label id="" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telfononf206"
        type="text"
        placeholder="95835877"
        className="form-control "
        id="i3fy2q"
      />
      
      </div>
      
      <div id="i9bvgf" className="">
      
      <label id="" className="">
      <>Cantidad de Personas</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="cantidaddepersonasd96qf"
        type="number"
        placeholder="10"
        className="form-control "
        id="ibxie4"
      />
      
      </div>
      
    <div id="i4k73l" className="">
    
      <label id="" className="">
      <>Descripción</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="descripcinns3bw" className="form-control " id="ik3nh3">
        
      </textarea>
      
    </div>
    
      <div id="i4xbwy" className="">
      
      <button
        type="submit"
        name=""
        id="iz80p2"
        className=""
        
      >
      
      <div id="idm4pm" className="">
      <>Enviar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      
      </form>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div className="" id="iyo7r6">
        <>Sabores auténticos de Honduras. Tradición, calidad y amor en cada platillo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="i78qcc">
        <>+504 9999-9999</>
      </div>
      
      <div className="" id="il1rnw">
        <>info@correo.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_carriton0fqi_app: (value) => dispatch(set_lofty_global_carriton0fqi(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Peventosr413q);
  